import { render, staticRenderFns } from "./AddTeamConfirmationComponent.vue?vue&type=template&id=d200fda0&"
import script from "./AddTeamConfirmationComponent.vue?vue&type=script&lang=js&"
export * from "./AddTeamConfirmationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports